<div class="admin-categories">
  <header class="page-header">
    <div class="header-content">
      <h1>
        <i class="fas fa-tags"></i>
        Gestion des Catégories
      </h1>
      <p class="subtitle">Organisez les catégories de menus des restaurants</p>
    </div>
    <div class="header-actions">
      <button (click)="openCreateModal()" class="btn btn-primary">
        <i class="fas fa-plus"></i>
        Nouvelle catégorie
      </button>
    </div>
  </header>

  <!-- Filtres -->
  <div class="filters-section">
    <div class="search-box">
      <i class="fas fa-search"></i>
      <input
        (ngModelChange)="onSearch($event)"
        [(ngModel)]="searchTerm"
        placeholder="Rechercher une catégorie..."
        type="text"
      />
    </div>
    <div class="filter-group">
      <select (ngModelChange)="onFilterChange()" [(ngModel)]="restaurantFilter">
        <option value="">Tous les restaurants</option>
        @for (restaurant of store.restaurants(); track restaurant.id) {
          <option [value]="restaurant.id">{{ restaurant.name }}</option>
        }
      </select>
      <select (ngModelChange)="onFilterChange()" [(ngModel)]="statusFilter">
        <option value="">Tous les statuts</option>
        <option value="active">Actives</option>
        <option value="inactive">Inactives</option>
      </select>
    </div>
  </div>

  <!-- Liste des catégories -->
  <div class="categories-container">
    @if (store.loading()) {
      <div class="loading-state">
        <div class="spinner"></div>
        <p>Chargement des catégories...</p>
      </div>
    } @else if (filteredCategories().length === 0) {
      <div class="empty-state">
        <i class="fas fa-folder-open"></i>
        <h3>Aucune catégorie trouvée</h3>
        <p>Créez votre première catégorie pour organiser les menus.</p>
        <button (click)="openCreateModal()" class="btn btn-primary">
          <i class="fas fa-plus"></i>
          Créer une catégorie
        </button>
      </div>
    } @else {
      <div class="categories-grid">
        @for (category of filteredCategories(); track category.id) {
          <div [cdkDragData]="category" [class.inactive]="!category.active"
               cdkDrag
               class="category-card">
            <div class="card-header">
              <div [style.background-color]="category.color || '#10b981'" class="category-icon">
                <i [class]="category.icon || 'fas fa-utensils'"></i>
              </div>
              <div class="category-info">
                <h3>{{ category.name }}</h3>
                <span class="restaurant-name">{{ category.restaurantName }}</span>
              </div>
              <div class="card-actions">
                <button (click)="editCategory(category)" class="btn-icon" title="Modifier">
                  <i class="fas fa-edit"></i>
                </button>
                <button (click)="deleteCategory(category)" class="btn-icon" title="Supprimer">
                  <i class="fas fa-trash"></i>
                </button>
              </div>
            </div>

            <div class="card-body">
              @if (category.description) {
                <p class="description">{{ category.description }}</p>
              }
              <div class="meta-info">
                    <span class="items-count">
                      <i class="fas fa-list"></i>
                      {{ category.itemsCount || 0 }} articles
                    </span>
                <span class="order-position">
                      <i class="fas fa-sort"></i>
                      Position: {{ category.displayOrder }}
                    </span>
              </div>
            </div>

            <div class="card-footer">
              <div class="status-toggle">
                <label class="toggle">
                  <input
                    (change)="toggleCategoryStatus(category)"
                    [checked]="category.active"
                    type="checkbox"
                  />
                  <span class="toggle-slider"></span>
                </label>
                <span class="status-label">{{ category.active ? 'Active' : 'Inactive' }}</span>
              </div>
              <span class="updated-date">
                    Mise à jour: {{ category.updatedAt | date:'dd/MM/yyyy' }}
                  </span>
            </div>
          </div>
        }
      </div>
    }
  </div>

  <!-- Modal création/édition -->
  @if (showModal()) {
    <div (click)="closeModal()" class="modal-overlay">
      <div (click)="$event.stopPropagation()" class="modal">
        <div class="modal-header">
          <h2>{{ editingCategory() ? 'Modifier la catégorie' : 'Nouvelle catégorie' }}</h2>
          <button (click)="closeModal()" class="btn-close">
            <i class="fas fa-times"></i>
          </button>
        </div>
        <form (ngSubmit)="saveCategory()" [formGroup]="categoryForm">
          <div class="modal-body">
            <div class="form-group">
              <label for="restaurant">Restaurant *</label>
              <select formControlName="restaurantId" id="restaurant">
                <option value="">Sélectionner un restaurant</option>
                @for (restaurant of store.restaurants(); track restaurant.id) {
                  <option [value]="restaurant.id">{{ restaurant.name }}</option>
                }
              </select>
              @if (categoryForm.get('restaurantId')?.invalid && categoryForm.get('restaurantId')?.touched) {
                <span class="error-text">Le restaurant est requis</span>
              }
            </div>

            <div class="form-group">
              <label for="name">Nom de la catégorie *</label>
              <input
                formControlName="name"
                id="name"
                placeholder="Ex: Entrées, Plats, Desserts..."
                type="text"
              />
              @if (categoryForm.get('name')?.invalid && categoryForm.get('name')?.touched) {
                <span class="error-text">Le nom est requis (min. 2 caractères)</span>
              }
            </div>

            <div class="form-group">
              <label for="description">Description</label>
              <textarea
                formControlName="description"
                id="description"
                placeholder="Description optionnelle de la catégorie..."
                rows="3"
              ></textarea>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label for="icon">Icône</label>
                <div class="icon-picker">
                  <div
                    [style.background-color]="categoryForm.get('color')?.value || '#10b981'"
                    class="icon-preview"
                  >
                    <i [class]="categoryForm.get('icon')?.value || 'fas fa-utensils'"></i>
                  </div>
                  <select formControlName="icon" id="icon">
                    <option value="fas fa-utensils">Couverts</option>
                    <option value="fas fa-pizza-slice">Pizza</option>
                    <option value="fas fa-hamburger">Burger</option>
                    <option value="fas fa-fish">Poisson</option>
                    <option value="fas fa-drumstick-bite">Viande</option>
                    <option value="fas fa-leaf">Végétarien</option>
                    <option value="fas fa-ice-cream">Dessert</option>
                    <option value="fas fa-coffee">Boissons</option>
                    <option value="fas fa-wine-glass-alt">Vin</option>
                    <option value="fas fa-beer">Bière</option>
                    <option value="fas fa-cocktail">Cocktail</option>
                    <option value="fas fa-cookie">Snacks</option>
                    <option value="fas fa-carrot">Légumes</option>
                    <option value="fas fa-cheese">Fromage</option>
                    <option value="fas fa-bread-slice">Pain</option>
                  </select>
                </div>
              </div>

              <div class="form-group">
                <label for="color">Couleur</label>
                <div class="color-picker">
                  <input
                    formControlName="color"
                    id="color"
                    type="color"
                  />
                  <span class="color-value">{{ categoryForm.get('color')?.value }}</span>
                </div>
              </div>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label for="displayOrder">Position d'affichage</label>
                <input
                  formControlName="displayOrder"
                  id="displayOrder"
                  min="0"
                  type="number"
                />
              </div>

              <div class="form-group">
                <label class="checkbox-label">
                  <input formControlName="active" type="checkbox"/>
                  <span>Catégorie active</span>
                </label>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button (click)="closeModal()" class="btn btn-secondary" type="button">
              Annuler
            </button>
            <button
              [disabled]="categoryForm.invalid || store.saving()"
              class="btn btn-primary"
              type="submit"
            >
              @if (store.saving()) {
                <span class="spinner-sm"></span>
              }
              {{ editingCategory() ? 'Modifier' : 'Créer' }}
            </button>
          </div>
        </form>
      </div>
    </div>
  }
</div>
